import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import Header from "./header";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Body from "./mainContent";
const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div className="App">
        <Header />
        <Stack
          direction="row"
          spacing={2}
          justifyContent="center"
          alignItems="flex-start"
          sx={{ mt: 2 }}
        >
          <Paper elevation={3} sx={{ p: 2, width: "60%" }}>
            <Body />
          </Paper>
        
        </Stack>
      </div>
    </ThemeProvider>
  );
}

export default App;
